import React from "react";

const DummyPage = () => {
  return <div>Dummy</div>;
};

export default DummyPage;
